import { Caption } from '@liveauctioneers/caterwaul-components/lib/Text/Text/';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getDeskSupportLink } from '@/utils/urls';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styled from 'styled-components';

type Props = {};

const SearchError = () => {
    return (
        <StyledErrorContainer>
            <div>
                <FormattedMessage id="search_error_1" />
            </div>
            <div>
                <span>
                    <FormattedMessage id="search_error_2" />
                </span>
                <Link
                    rel="noopener"
                    target="_blank"
                    to={getDeskSupportLink()}
                >
                    <FormattedMessage id="search_error_contact_support" />
                </Link>
                <span>
                    <FormattedMessage id="search_error_3" />
                </span>
            </div>
        </StyledErrorContainer>
    );
};

export default React.memo<Props>(SearchError);

const StyledErrorContainer = styled(Caption)`
    width: 100%;
    height: 158px;
    padding-top: 55px;
    border: 1px solid ${({ theme }) => theme.colors.grey400};
    text-align: center;
    letter-spacing: 0.2px;
    color: ${({ theme }) => theme.colors.grey100};

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        height: 127px;
        padding: 21px 10px 34px 16px;
    }

    a {
        text-decoration: underline;
        cursor: pointer;
    }
`;
